export const APPEARANCE_MODE_LIGHT = 'LIGHT' as const;
export const APPEARANCE_MODE_DARK = 'DARK' as const;

export const APPEARANCE_ENUMS = [APPEARANCE_MODE_LIGHT, APPEARANCE_MODE_DARK] as const;

export const SPACING = 4 as const;

export const VARIANT_TEXT = 'text' as const;
export const VARIANT_OUTLINED = 'outlined' as const;
export const VARIANT_FILLED = 'filled' as const;

export const SHAPE_SQUARE = 'square' as const;
export const SHAPE_ROUNDED = 'rounded' as const;
export const SHAPE_CIRCULAR = 'circular' as const;

export const SIZE_X_SMALL = 'xSmall' as const;
export const SIZE_SMALL = 'small' as const;
export const SIZE_MEDIUM = 'medium' as const;
export const SIZE_LARGE = 'large' as const;
export const SIZE_X_LARGE = 'xLarge' as const;

export const CUSTOM_ATTRIBUTE_SHAPE = 'data-shape' as const;
export const CUSTOM_ATTRIBUTE_SIZE = 'data-size' as const;
export const CUSTOM_ATTRIBUTE_FULL_WIDTH = 'data-full-width' as const;
export const CUSTOM_ATTRIBUTE_SQUARE = 'data-is-square' as const;
export const CUSTOM_ATTRIBUTE_MULTILINE = 'data-is-multiline' as const;
export const CUSTOM_ATTRIBUTE_OVERLAY_EDIT = 'data-overlay-edit' as const;
export const CUSTOM_ATTRIBUTE_SINGLE_COLOR = 'data-single-color' as const;
export const CUSTOM_ATTRIBUTE_MARGIN = 'data-margin' as const;
export const CUSTOM_ATTRIBUTE_READ_ONLY = 'data-read-only' as const;
export const CUSTOM_ATTRIBUTE_FONT_WEIGHT = 'data-font-weight' as const;
export const CUSTOM_ATTRIBUTE_LIST_STYLE = 'data-list-style' as const;
export const CUSTOM_ATTRIBUTE_COLOR = 'data-color' as const;
export const CUSTOM_ATTRIBUTE_FLEX_WRAP = 'data-flex-wrap' as const;
export const CUSTOM_ATTRIBUTE_ELEVATION = 'data-elevation' as const;
export const CUSTOM_ATTRIBUTE_EQUAL_WIDTH = 'data-is-equal-width' as const;
export const CUSTOM_ATTRIBUTE_TEXT_ALIGN = 'data-text-align' as const;
export const CUSTOM_ATTRIBUTE_TEXT_TRANSFORM = 'data-text-transform' as const;
export const CUSTOM_ATTRIBUTE_FILLED_TYPE = 'data-filled-type' as const;
export const CUSTOM_ATTRIBUTE_NO_WRAP = 'data-no-wrap' as const;
export const CUSTOM_ATTRIBUTE_AUTO_WIDTH = 'data-auto-width' as const;
